window.coma = window.coma || {};

window.coma.mediaqueries = (function ($, undefined) {

    // PRIVATE FUNCTIONS
    var _private = {
        lastDevice: null,
        init: function() {
            // create the mediaqueries element
            $('body').append('<div id="mediaqueries"></div>');
            this.lastDevice = this.getDevice();
            this.addEventListener();
        },
        getDevice: function() {

            // ie8 does not know window.getComputedStyle
            if (!window.getComputedStyle) {
                // so in this case we will use the z-index
                switch ($('#mediaqueries').css('z-index')) {
                    case 1:
                        return 'xs';
                        break;
                    case 2:
                        return 'sm';
                        break;
                    case 3:
                    default:
                        return 'md';
                        break;
                    case 4:
                        return 'lg';
                        break;
                }
            }
            else {
                var tmp = window.getComputedStyle(
                    document.querySelector('#mediaqueries'), ':before'
                ).getPropertyValue('content');
            }

            // for some reason the IE browsers (even the new ones) add quotas to the parameter
            return tmp.replace(/"/g, '');
        },
        addEventListener: function() {
            $(window).on('resize', function() {
                var newDevice = _private.getDevice();
                if (_private.lastDevice != newDevice) {
                    _private.lastDevice = newDevice;
                    $(document).trigger({
                        type: 'mediaqueries-changed',
                        message: newDevice
                    });
                }
            });
        }
    }

    // CALL INIT
    $(document).ready(function() {
        _private.init();
    });

    // PUBLIC FUNCTIONS
    return {
        getDevice: function() {
            return _private.getDevice();
        }
    }

}(jQuery));